import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const AdminMenuRoute = lazyWithRetries(() => import('./AdminMenu'))
const MenuRoute = lazyWithRetries(() => import('./Menu'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.adminMenu(),
    element: (
      <StandardPageLayout
        elementId="notificationsRoute"
        maxWidth={600}
        title={<T _str="Admin Menu" />}>
        <Suspense fallback={<RouteLoading />}>
          <AdminMenuRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.menu(),
    element: (
      <StandardPageLayout elementId="menuRoute" maxWidth="100%" title={<T _str="Menu" />}>
        <Suspense fallback={<RouteLoading />}>
          <MenuRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
